import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import defaultUrl from "@/resource/images/default-banner.png";
import YYImage from '@/pages/design/components/basic/image';
import YYCarousel from '@/pages/design/components/basic/carousel';
import YYCarouselItem from '@/pages/design/components/basic/carousel-item';
import { mapState } from 'vuex';
import noImg from "@/assets/noimg.png";

// const  value ={
//       data: {
//         "pathlink": [
//
//         ],
//       },
//       style: {
//         m: {
//           height: 198,
//           paddingTop: 0,
//           paddingBottom: 0,
//         },
//         pc: {
//           "height": 300,
//           "paddingTop": "36",
//           "paddingBottom": "18"
//         }
//       }
//     }
export default {
  name: "Swiper",
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // 轮播图设置
      defaultUrl: defaultUrl,
      noImg: noImg
    };
  },
  created: function created() {
    // if(!Object.keys(this.formData).length){
    //   this.$emit('update:formData', value)
    // }
  },
  components: {
    YYImage: YYImage,
    YYCarousel: YYCarousel,
    YYCarouselItem: YYCarouselItem
  },
  computed: _objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.design.imgHost;
    },
    platform: function platform(state) {
      return state.design.platform;
    }
  })),
  methods: {
    goToPage: function goToPage() {}
  }
};